import { api } from '../auth/apiClient';

const API_URL = process.env.REACT_APP_API_BASE_URL || '/api';

const unwrap = (payload) => (
    payload && typeof payload === 'object' && 'data' in payload ? payload.data : payload
);

export const fetchCompanyList = async () => {
    const res = await fetch(`${API_URL}/finlytics/companies`);
    if (!res.ok) {
        throw new Error(`Failed to fetch companies: ${res.status}`);
    }
    const payload = await res.json();
    // Backend wraps the list under "data"
    if (Array.isArray(payload)) return payload;
    if (payload && Array.isArray(payload.data)) return payload.data;
    return [];
};

const portfolioError = (err, fallback) => {
    const data = err?.response?.data;
    return data?.message || data?.detail || err?.message || fallback;
};

export const fetchUserPortfolio = async () => {
    const payload = await api.get('/finlytics/portfolio');
    const data = unwrap(payload);
    return Array.isArray(data) ? data : [];
};

export const addCompanyToPortfolio = async (companyId) => {
    try {
        const payload = await api.post(
            '/finlytics/portfolio',
            { companyId },
            { timeout: 180000 }
        );
        return unwrap(payload);
    } catch (err) {
        throw new Error(portfolioError(err, 'Failed to add company.'));
    }
};

export const removeCompanyFromPortfolio = async (companyId) => {
    try {
        const payload = await api.delete(
            `/finlytics/portfolio/${encodeURIComponent(companyId)}`
        );
        return unwrap(payload);
    } catch (err) {
        throw new Error(portfolioError(err, 'Failed to remove company.'));
    }
};
